import { useMutation } from '@tanstack/react-query';
import {
  DEMO_FILL_FORM_MUTATION_KEY,
  type FillFormDemoRequest,
  type FillFormDemoResponse,
} from '../../contracts';
import { fillFormDemo } from '../api/templates';

export function useMutateFillFormDemo() {
  return useMutation<FillFormDemoResponse, Error, FillFormDemoRequest>({
    mutationKey: DEMO_FILL_FORM_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async (request) => {
      const { data } = await fillFormDemo(request);
      return data;
    },
  });
}
